module.exports = __webpack_public_path__ + "img/shipo-icon-search.4a7747bf.svg";